import { FilesSubscriptionProvider } from '../../FilesSubscriptionProvider';

import { FileBulkDeleteDialog } from './FileBulkDeleteDialog';
import { FileBulkMoveDialog } from './FileBulkMoveDialog';
import { FileDeleteDialog } from './FileDeleteDialog';
import { FileExplorer } from './FileExplorer';
import { FileMoveDialog } from './FileMoveDialog';
import { FileRenameDialog } from './FileRenameDialog';
import { FileSetTemplateDialog } from './FileSetTemplateDialog';
import { FileUploadDialog } from './FileUploadDialog';
import { FolderCreateDialog } from './FolderCreateDialog';

export const FilesExplorerView = () => (
  <FilesSubscriptionProvider>
    <div className="@FilesExplorerView contents">
      <FileExplorer />
      <FileUploadDialog />
      <FolderCreateDialog />
      <FileRenameDialog />
      <FileMoveDialog />
      <FileDeleteDialog />
      <FileBulkDeleteDialog />
      <FileBulkMoveDialog />
      <FileSetTemplateDialog />
    </div>
  </FilesSubscriptionProvider>
);
